import { render, staticRenderFns } from "./TableBlock.vue?vue&type=template&id=c26447c6&scoped=true"
import script from "./TableBlock.vue?vue&type=script&lang=js"
export * from "./TableBlock.vue?vue&type=script&lang=js"
import style0 from "./TableBlock.vue?vue&type=style&index=0&id=c26447c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26447c6",
  null
  
)

export default component.exports